import { useEffect } from "react";
import { useMap } from "react-leaflet";
import type L from "leaflet";
import { wheelZoomTarget } from "../model/helpers/wheel-zoom-target";

type WheelHandler = L.Handler & {
  _delta: number;
  _startTime: number | null;
  _lastMousePos: L.Point;
  _performZoom: () => void;
};

export function WholeStepWheelZoom() {
  const map = useMap();

  useEffect(() => {
    const handler = map.scrollWheelZoom as WheelHandler;
    handler._performZoom = function performZoom(this: WheelHandler) {
      // Not map.stop(): that also re-snaps the zoom, as Leaflet's own handler avoids.
      (map as unknown as { _stop: () => void })._stop();
      const zoom = map.getZoom();
      const target = wheelZoomTarget(zoom, this._delta, map.options.wheelPxPerZoomLevel!);
      this._delta = 0;
      this._startTime = null;
      const next = Math.max(map.getMinZoom(), Math.min(map.getMaxZoom(), target));
      if (next !== zoom) map.setZoomAround(this._lastMousePos, next);
    };
    return () => {
      delete (handler as Partial<WheelHandler>)._performZoom;
    };
  }, [map]);

  return null;
}
